import { Map } from "immutable";
import { createSelector } from "reselect";

import { typeSelectors } from "../../modules/definition/types";
import { displayCacheSelectors } from "../../modules/display";
import { itemSelectors } from "../../modules/items";
import { immutableRecords } from "../../types";

const getWarningsCount = createSelector(
  // inputs
  displayCacheSelectors.getViolatedDependencies,
  displayCacheSelectors.getViolatedDateConstraints,
  // calculate based on inputs
  (dependencies, constraints) => dependencies.size + constraints.size
);

// Get constraints divided by item
const getConstraintsByItem = createSelector(
  // inputs
  displayCacheSelectors.getValidatedDependencies,
  displayCacheSelectors.getValidatedDateConstraints,
  itemSelectors.getItemsById,
  typeSelectors.getTypesById,
  // calculate based on inputs
  (dependencies, constraints, itemsById, typesById) => {
    // Get a count of violations per itemId
    let counts = {};
    dependencies.map(d => {
      const addCount = d.isViolated ? 1 : 0;
      counts[d.subject] = counts[d.subject] ? counts[d.subject] + addCount : addCount;
      if (d.object) {
        counts[d.object] = counts[d.object] ? counts[d.object] + addCount : addCount;
      }
    });
    constraints.map(d => {
      const addCount = d.isViolated ? 1 : 0;
      counts[d.subject] = counts[d.subject] ? counts[d.subject] + addCount : addCount;
      if (d.object) {
        counts[d.object] = counts[d.object] ? counts[d.object] + addCount : addCount;
      }
    });

    return Map(counts).map((c, id) => {
      const item = itemsById.get(id);
      const type = typesById.get(item.type);
      return immutableRecords.ConstraintWarningRecord({
        subject: id,
        label: item.label,
        typeIcon: type.icon,
        typeIconColor: type.color,
        isViolated: Boolean(c > 0)
      });
    });
  }
);

export default {
  getWarningsCount,
  getConstraintsByItem
};
